export type HudMode = "play" | "farm" | "companions";
export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

/** UI 和相机共享同一布局契约；控制区占空间，不再任意叠在世界中央。 */
export function gameLayout(
  width: number,
  height: number,
  mode: HudMode,
  touch: boolean,
  safeTop = 0,
  safeBottom = 0,
  expedition = false,
  safeLeft = 0,
  safeRight = 0,
) {
  const compact = touch || width < 1000 || height < 600;
  const portrait = width < 700 && height > width;
  // 短横屏战斗把摇杆、工具排除到两翼，避免整条底栏把首领裁成仅剩脚部。
  const combatWings =
    compact && !portrait && mode === "play" && width >= 700 && height < 600;
  const top =
    (portrait ? 116 : compact ? 64 : 82) + (expedition ? 46 : 0) + safeTop;
  const panelHeight = Math.min(324, Math.round(height * 0.47));
  const side = mode !== "play" && !portrait;
  const sideWidth = Math.min(360, Math.round(width * 0.43));
  const bottom = combatWings
    ? 8 + safeBottom
    : mode === "play"
      ? (portrait ? 152 : 90) + safeBottom
      : portrait
        ? panelHeight + safeBottom
        : 16 + safeBottom;
  const viewport: Rect = {
    x: (combatWings ? 120 : 0) + safeLeft,
    y: top,
    width:
      (combatWings ? width - 340 : width - (side ? sideWidth + 20 : 0)) -
      safeLeft -
      safeRight,
    height: Math.max(80, height - top - bottom),
  };
  const panel: Rect = portrait
    ? {
        x: 8,
        y: height - panelHeight - safeBottom,
        width: width - 16,
        height: panelHeight,
      }
    : {
        x: width - sideWidth - 10,
        y: top,
        width: sideWidth,
        height: Math.max(100, height - top - safeBottom - 12),
      };
  return { viewport, panel, compact, portrait, bottom, top, combatWings };
}
